import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M991 512 1055 768H801L737 512ZM1759 1016 1703 792Q1696 768 1672 768H1345L1281 512H1592Q1607 512 1617 500Q1627 486 1623 472L1567 248Q1562 224 1536 224H1209L1128 -104Q1121 -128 1097 -128H873Q857 -128 847 -116Q838 -104 841 -88L919 224H665L584 -104Q577 -128 553 -128H328Q313 -128 303 -116Q294 -104 297 -88L375 224H64Q49 224 39 236Q30 248 33 264L89 488Q96 512 120 512H447L511 768H200Q185 768 175 780Q165 794 169 808L225 1032Q230 1056 256 1056H583L664 1384Q671 1408 696 1408H920Q935 1408 945 1396Q954 1384 951 1368L873 1056H1127L1208 1384Q1215 1408 1240 1408H1464Q1479 1408 1489 1396Q1498 1384 1495 1368L1417 1056H1728Q1743 1056 1753 1044Q1762 1032 1759 1016Z"
	})
});
export default SvgTag;
